module.exports = __webpack_public_path__ + "media/npc_dota_hero_ember_spirit.fc55fa98.webm";